import React, { Component } from "react";
import TagBlock from "../tag/TagBlock";
import TagRedBlock from "../tag/TagRedBlock";
import CasesBlockNew from "./CasesBlockNew";
import history from "../../history";

const initData = (lang) => window?.cases[lang];
// const cases = window?.cases[this.props.lang];
const en = [
  {
    id: "askthestars",
    tag: "",
    tagsCase: "",
    image: "/img/restotchet-case.webp",
    title: "Ask the stars",
    text: "Mobile app for IOS and Android",
  },
  {
    id: "getcoach",
    tag: "",
    tagsCase: "",
    image: "/img/restotchet-case.webp",
    title: "Get Coach",
    text: "Fitness app Get Coach with a 4.9 rating",
  },
  {
    id: "barlondon",
    tag: "",
    tagsCase: "",
    image: "/img/london-case-new.webp",
    title: "Bar London",
    text: "Mobile app for IOS and Android",
  },
  {
    id: "projectnda",
    tag: "",
    tagsCase: "",
    image: "/img/restotchet-case.webp",
    title: "NDA project",
    text: "NDA project to track promotions and discounts",
  },
  {
    id: "fotobox",
    tag: "",
    tagsCase: "",
    image: "/img/restotchet-case.webp",
    title: "FotoBox",
    text: "Application for restaurants “FotoBox”",
  },
  {
    id: "restotchet",
    tag: "",
    tagsCase: "",
    image: "/img/restotchet-case.webp",
    title: "Restotchet",
    text: "Application for business automatization “Restotchet”",
  },
  {
    id: "zharptica",
    tag: "",
    tagsCase: "",
    image: "/img/restotchet-case.webp",
    title: "ZHar-ptica",
    text: "Development of a mobile app for IOS and Android",
  },
  {
    id: "giveawayapp",
    tag: "",
    tagsCase: "",
    image: "/img/restotchet-case.webp",
    title: "Giveaway App",
    text: "Innovative FinTech app for Nigeria",
  },
  {
    id: "myenergystream",
    tag: "",
    tagsCase: "",
    image: "/img/restotchet-case.webp",
    title: "My energy stream",
    text: "A multiplatform mobile app for meditation",
  },
];

const ru = [
  {
    id: "fotobox",
    tag: "#фудтех",
    tagsCase: [
      { name: "#вебразработка", url: "web" },
      { name: "#python", url: "python" },
      { name: "#reactjs", url: "react" },
      { name: "#fastapi", url: "fastapi" },
      { name: "#typescript", url: "typescript" },
      { name: "#автоматизацияпроцессов", url: "automation" },
      { name: "#django", url: "django" },
      { name: "#postgresql", url: "postgres" },
      { name: "#agile", url: "agile" },
    ],
    image: "/img/fotobox-case-512.webp",
    title: "FotoBox",
    text: "Читайте наш кейс о том, как исключить злоупотребление персонала и повысить качество сервиса с помощью одного программного обеспечения для ресторанов и кафе.",
  },
  {
    id: "giveawayapp",
    tag: "#финтех",
    tagsCase: [
      { name: "#мобильнаяразработка", url: "mobile" },
      { name: "#python", url: "python" },
      { name: "#flutter", url: "flutter" },
      // { name: "#postgres", url: "postgres" },
      { name: "#django", url: "django" },
      { name: "#кроссплатформеннаяразработка", url: "crossplatform" },
      { name: "#agile", url: "agile" },
    ],
    image: "/img/giveaway-case.webp",
    title: "Giveaway App",
    text: "Кейс о том, как мы разработали финтех приложение для проведения безопасных финансовых транзакций на рынке Нигерии, а потом и во всей Африке.",
  },
  {
    id: "restotchet",
    tag: "#фудтех",
    tagsCase: [
      { name: "#вебразработка", url: "web" },
      { name: "#python", url: "python" },
      { name: "#reactjs", url: "react" },
      { name: "#typescript", url: "typescript" },
      { name: "#fastapi", url: "fastapi" },
      { name: "#автоматизацияпроцессов", url: "automation" },
      { name: "#postgresql", url: "postgres" },
      { name: "#django", url: "django" },
      { name: "#agile", url: "agile" },
    ],
    image: "/img/restotchet-case.webp",
    title: "Restotchet",
    text: "Кейс по разработке приложения для ресторанов LRG.  Мы автоматизировали отчетность и финансовый учет, благодаря этому ресторатору удалось сократить издержки на 12%.",
  },
  {
    id: "projectnda",
    tag: "#лайфстайл",
    tagsCase: [
      { name: "#мобильнаяразработка", url: "mobile" },
      { name: "#python", url: "python" },
      { name: "#swift", url: "swift" },
      { name: "#kotlin", url: "kotlin" },
      { name: "#нативнаяразработка", url: "native" },
      { name: "#agile", url: "agile" },
    ],
    image: "/img/nda-case-512.webp",
    title: "Проект NDA",
    text: "В этом кейсы мы рассказываем, как разработали приложение под ключ, которое в короткие сроки покрыло все затраты на его создание.",
  },
  {
    id: "zharptica",
    tag: "#стартапы",
    tagsCase: [
      { name: "#мобильнаяразработка", url: "mobile" },
      { name: "#вебразработка", url: "web" },
      { name: "#python", url: "python" },
      { name: "#typescript", url: "typescript" },
      { name: "#cmsbitrix", url: "cmsbitrix" },
      { name: "#reactnative", url: "reactnative" },
      { name: "#кроссплатформеннаяразработка", url: "crossplatform" },
      { name: "#agile", url: "agile" },
    ],
    image: "/img/jar-bird-case.webp",
    title: "Жар-птица",
    text: "Кейс по разработке приложения доставки. Мы создали IT-систему, которая увеличила приток новых гостей и сократила затраты на рекламу и пластиковые карты.",
  },
  {
    id: "avt",
    tag: "#жкх",
    tagsCase: [
      { name: "#мобильнаяразработка", url: "mobile" },
      { name: "#reactjs", url: "react" },
      { name: "#flutter", url: "flutter" },
      { name: "#вебразработка", url: "web" },
      { name: "#python", url: "python" },
      { name: "#typescript", url: "typescript" },
      { name: "#asterisk", url: "asterisk" },
      { name: "#django", url: "django" },
      { name: "#кроссплатформеннаяразработка", url: "crossplatform" },
      { name: "#agile", url: "agile" },
    ],
    image: "/img/avt-case-512.webp",
    title: "Домофония",
    text: "Рассказываем о разработке web-приложения и ПО с нуля для компании ЖКХ.",
  },
  {
    id: "barlondon",
    tag: "#фудтех",
    tagsCase: [
      { name: "#мобильнаяразработка", url: "mobile" },
      { name: "#python", url: "python" },
      { name: "#flutter", url: "flutter" },
      // { name: "#postgresql", url: "postgres" },
      // { name: "#django", url: "django" },
      { name: "#кроссплатформеннаяразработка", url: "crossplatform" },
      { name: "#agile", url: "agile" },
    ],
    image: "/img/london-case-512.webp",
    title: "Бар Лондон",
    text: "Рассказываем о кейсе с London Group — сетью баров и ресторанов. Компания обратилась за разработкой мобильного приложения, которое в итоге увеличило продажи на 20%.",
  },
  {
    id: "myenergystream",
    tag: "#лайфстайл",
    tagsCase: [
      { name: "#мобильнаяразработка", url: "mobile" },
      // { name: "#python", url: "python" },
      { name: "#flutter", url: "flutter" },
      { name: "#firebase", url: "firebase" },
      { name: "#unity", url: "unity" },
      { name: "#кроссплатформеннаяразработка", url: "crossplatform" },
      { name: "#agile", url: "agile" },
    ],
    image: "/img/med-case-512.webp",
    title: "My energy stream",
    text: "Наша история о том, как мы создали приложение для медитации с затягивающим игровым функционалом всего за 2 месяца работы.",
  },
  {
    id: "aromateaka",
    tag: "#фудтех",
    tagsCase: [
      { name: "#мобильнаяразработка", url: "mobile" },
      { name: "#python", url: "python" },
      { name: "#flutter", url: "flutter" },
      { name: "#django", url: "django" },
      { name: "#кроссплатформеннаяразработка", url: "crossplatform" },
      { name: "#agile", url: "agile" },
    ],
    image: "/img/aroma-case-512.webp",
    title: "Aromateaka",
    text: "Как мы разработали приложение для любителей чая и профессиональных сомелье — «чайный вариант ВКонтакте» с игровыми тренировками обоняния и библиотекой ароматов.",
  },
  {
    id: "ar",
    tag: "#стартапы",
    tagsCase: [
      { name: "#вебразработка", url: "web" },
      { name: "#ar/vr", url: "vr" },
      { name: "#unity", url: "unity" },
      { name: "#varwin", url: "varwin" },
    ],
    image: "/img/ar-case-512.webp",
    title: "AR/VR",
    text: "Мы разработали приложение с AR и VR реальностью для обучения новых сотрудников и студентов, которое увеличило показатели школьных и профессиональных экзаменах.",
  },
  {
    id: "getcoach",
    tag: "#лайфстайл",
    tagsCase: [
      { name: "#мобильнаяразработка", url: "mobile" },
      { name: "#python", url: "python" },
      { name: "#reactnative", url: "reactnative" },
      { name: "#typescript", url: "typescript" },
      // { name: "#postgresql", url: "postgres" },
      { name: "#django", url: "django" },
      { name: "#кроссплатформеннаяразработка", url: "crossplatform" },
      { name: "#agile", url: "agile" },
    ],
    image: "/img/getcouch-case.webp",
    title: "Get Coach",
    text: "История о том, как мы разработали и выпустили приложение для фитнеса. Сейчас его рейтинг 5.0, и оно привлекло более 250 тренеров всего за 1.5 месяца!",
  },

  {
    id: "simposiy",
    tag: "#фудтех",
    tagsCase: [
      { name: "#мобильнаяразработка", url: "mobile" },
      { name: "#python", url: "python" },
      { name: "#flutter", url: "flutter" },
      // { name: "#postgresql", url: "postgres" },
      { name: "#django", url: "django" },
      { name: "#кроссплатформеннаяразработка", url: "crossplatform" },
      { name: "#agile", url: "agile" },
    ],
    image: "/img/simposiy-case-512.webp",
    title: "Simposiy",
    text: "Как мы работали с фудтех стартапом и разработали уникальный фудтех сервис, который стирает границы между владельцами ресторанного бизнеса и их клиентами.",
  },
  {
    id: "control",
    tag: "#жкх",
    tagsCase: [
      { name: "#мобильнаяразработка", url: "mobile" },
      { name: "#reactnative", url: "reactnative" },
      { name: "#typescript", url: "typescript" },
      { name: "#nodejs", url: "node" },
      { name: "#кроссплатформеннаяразработка", url: "crossplatform" },
      { name: "#agile", url: "agile" },
    ],
    image: "/img/control-case-512.webp",
    title: "Приложение «Абонент ЖКХ»",
    text: "Мы создали приложение для управляющей компании, которое упростило документооборот, сократило количество бумажной работы и дебиторскую задолженность клиентов.",
  },

  // {
  //   id: "metka",
  //   tag: "#Стартапы",
  //   tagsCase: [
  //     "#мобильнаяразработка",
  //     "Kotlin",
  //     "JS",
  //     "#кроссплатформеннаяразработка",
  //     "Firebase",
  //   ],
  //   image: "/img/restotchet-case.webp",
  //   title: "Приложение «Метка» для экскурсий",
  //   text: "Приложение для управляющей компании",
  // },
  {
    id: "slimgame",
    tag: "#стартапы",
    tagsCase: [
      { name: "#мобильнаяразработка", url: "mobile" },
      { name: "#python", url: "python" },
      { name: "#reactnative", url: "reactnative" },
      { name: "#django", url: "django" },
      { name: "#typescript", url: "typescript" },
      { name: "#кроссплатформеннаяразработка", url: "crossplatform" },
      { name: "#agile", url: "agile" },
    ],
    image: "/img/slim-case-512.webp",
    title: "Slimgame",
    text: "Кейс ItFox: как мы разработали мобильное приложение для фитнеса с возможностью получать деньги за похудение. Это, кстати, первое такое приложение на российском рынке.",
  },
  {
    id: "automation",
    tag: "#жкх",
    tagsCase: [
      { name: "#автоматизацияпроцессов", url: "automation" },
      { name: "#agile", url: "agile" },
    ],
    image: "/img/automation-case-512.webp",
    title: "Automation",
    text: "После внедрения этого IT-решения наш заказчик увеличил количество заказов и прибыль. Хотя раньше из-за несовершенства системы эти задачи были невыполнимыми.",
  },
  {
    id: "medication",
    tag: "#стартапы",
    tagsCase: [
      { name: "#мобильнаяразработка", url: "mobile" },
      { name: "#reactnative", url: "reactnative" },
      { name: "#typescript", url: "typescript" },
      { name: "#nodejs", url: "node" },
      // { name: "#firebase", url: "firebase" },
      { name: "#кроссплатформеннаяразработка", url: "crossplatform" },
      { name: "#agile", url: "agile" },
    ],
    image: "/img/medication-case-512.webp",
    title: "Моя таблеточница",
    text: "Мы разработали программу для медицинского центра. Это приложение повысило уровень лояльности его посетителей и увеличило количество постоянных клиентов.",
  },
  {
    id: "askthestars",
    tag: "#лайфстайл",
    tagsCase: [
      { name: "#мобильнаяразработка", url: "mobile" },
      { name: "#reactnative", url: "reactnative" },
      { name: "#python", url: "python" },
      { name: "#typescript", url: "typescript" },
      // { name: "#postgresql", url: "postgres" },
      { name: "#django", url: "django" },
      { name: "#кроссплатформеннаяразработка", url: "crossplatform" },
      { name: "#agile", url: "agile" },
    ],
    image: "/img/star-case.webp",
    title: "Спроси у звезд",
    text: "Наш кейс о том, как мы создали астрологическое приложение для проверки на совместимость с абсолютно точным данными за счёт специально разработанного сервера.",
  },
];

export const tags = [
  {
    text: "#стартапы",
    url: "startup",
    img: "/img/start-up.svg",
  },
  {
    text: "#финтех",
    url: "fintech",
    img: "/img/Fintech.svg",
  },
  {
    text: "#фудтех",
    url: "restaurant",
    img: "/img/Foodtech.svg",
  },
  {
    text: "#лайфстайл",
    url: "lifestyle",
    img: "/img/life-style.svg",
  },
  {
    text: "#жкх",
    url: "utilities",
    img: "/img/jkh.svg",
  },
];

class CasesSection extends Component {
  state = {
    langData: [],
    data: [],
    tagsSecondLevel: [],
    currenttagsSecondLevel: null,
    currentFilters: "",
  };

  componentDidMount() {
    const params = new URLSearchParams(history.location.search);
    const getSearch = params.get("tag");
    const getSearchCase = params.get("tagcase");
    this.setState({
      langData: initData(this.props.lang),
      data: initData(this.props.lang),
    });
    const urlTag = tags.find((tag) => tag.url === getSearch);

    this.setState({
      currentFilters: urlTag?.text,
    });
    setTimeout(() => {
      this.choiceCases();
      this.choiceFiltersSecond();
      const urlTagCase = this.state.tagsSecondLevel.find(
        (item) => item.url === getSearchCase
      );
      this.choiceCurrenttagsSecondLevel(urlTagCase);
      this.choiceCasesLevel();
    }, 1000);
  }
  choiceFilters = (tag) => {
    this.setState((prevState) => {
      if (prevState.currentFilters !== tag.text) {
        return {
          currentFilters: tag.text,
        };
      }
      if (prevState.currentFilters === tag.text) {
        return {
          currentFilters: "",
        };
      }
    });
  };

  choiceCases = () => {
    this.setState((prevState) => {
      if (prevState.currentFilters?.length > 0) {
        return {
          data: this.state.langData.filter(
            (item) => prevState.currentFilters === item.tag
          ),
        };
      }
      if (prevState.currentFilters === "") {
        return {
          data: this.state.langData,
        };
      }
    });
  };

  choiceCasesLevel = () => {
    this.setState((prevState) => {
      if (prevState.currenttagsSecondLevel && prevState.currentFilters) {
        return {
          data: this.state.langData.filter(
            (item) =>
              prevState.currentFilters === item.tag &&
              item.tagsCase.find(
                (item) => item.name === prevState.currenttagsSecondLevel.name
              )
          ),
        };
      }
      if (prevState.currenttagsSecondLevel && !prevState.currentFilters) {
        return {
          data: this.state.langData.filter((item) =>
            item.tagsCase.find(
              (item) => item.name === prevState.currenttagsSecondLevel.name
            )
          ),
        };
      }
      if (!prevState.currenttagsSecondLevel && prevState.currentFilters) {
        return {
          data: this.state.langData.filter(
            (item) => prevState.currentFilters === item.tag
          ),
        };
      }
      if (!prevState.currenttagsSecondLevel && !prevState.currentFilters) {
        return {
          data: this.state.langData,
        };
      }
    });
  };

  choiceFiltersSecond(value) {
    this.setState((prevState) => {
      const t = prevState.data.map((item) => item.tagsCase).flat(1);
      return {
        tagsSecondLevel: [
          ...new Set(t.map((item) => JSON.stringify(item))),
        ].map((item) => JSON.parse(item)),
      };
    });
  }

  choiceCurrenttagsSecondLevel = (tag) => {
    this.setState((prevState) => {
      if (prevState.currenttagsSecondLevel?.name !== tag?.name) {
        return {
          currenttagsSecondLevel: tag,
        };
      }
      if (prevState.currenttagsSecondLevel?.name === tag?.name) {
        return {
          currenttagsSecondLevel: "",
        };
      }
    });
  };

  render() {
    return (
      <section id="cases-new" className="section py-3">
        <span id="cases-label-new"></span>
        <div className="container">
          <div className="tag-block-wrap h-100 mt-1">
            <div className="mt-2 tag-ul row m-0">
              {tags.map((tag, index) => (
                <TagBlock
                  key={index}
                  lang={this.props.lang}
                  class={this.state.currentFilters === tag.text ? "active" : ""}
                  tag={tag}
                  onClick={() => {
                    this.choiceFilters(tag);
                    this.state.currentFilters !== tag.text
                      ? history.push(
                          `/portfolio/ru/?tag=${tag.url}${
                            this.state.currenttagsSecondLevel
                              ? "&tagCase=" +
                                this.state.currenttagsSecondLevel.url
                              : ""
                          }`
                        )
                      : history.push(
                          `/portfolio/ru/?${
                            this.state.currenttagsSecondLevel
                              ? "&tagCase=" +
                                this.state.currenttagsSecondLevel.url
                              : ""
                          }`
                        );
                    this.choiceCases();
                    this.choiceCurrenttagsSecondLevel(null);
                    this.choiceFiltersSecond();
                    this.choiceCasesLevel();
                  }}
                />
              ))}
            </div>
            <hr />
            <div className="mt-2 mb-2 tag-ul row m-0">
              {this.state.tagsSecondLevel &&
                this.state.tagsSecondLevel.map((t, index) => (
                  <TagRedBlock
                    key={index}
                    lang={this.props.lang}
                    tag={t}
                    class={
                      this.state.currenttagsSecondLevel?.name === t.name
                        ? "active"
                        : ""
                    }
                    onClick={() => {
                      this.choiceCases();
                      this.state.currenttagsSecondLevel?.name !== t.name
                        ? history.push(
                            `/portfolio/ru/?tagCase=${t.url}${
                              this.state.currentFilters
                                ? "&tag=" +
                                  tags.find(
                                    (tag) =>
                                      tag.text === this.state.currentFilters
                                  ).url
                                : ""
                            }`
                          )
                        : history.push(
                            `/portfolio/ru/?${
                              this.state.currentFilters
                                ? "&tag=" +
                                  tags.find(
                                    (tag) =>
                                      tag.text === this.state.currentFilters
                                  ).url
                                : ""
                            }`
                          );
                      this.choiceCurrenttagsSecondLevel(t);
                      this.choiceCasesLevel();
                    }}
                  />
                ))}
            </div>
          </div>
          <div className="row">
            {this.state.data?.map((element, index) => (
              <CasesBlockNew
                key={index}
                title={element?.title}
                idCase={element?.id}
                main={false}
                image={element?.image}
                text={element?.text}
                tagsCase={element?.tagsCase}
                lang={this.props.lang}
                page={this.props.page}
                currenttagsSecondLevel={this.state.currenttagsSecondLevel}
                onClick={(value) => {
                  this.choiceCurrenttagsSecondLevel(value);
                  this.choiceCasesLevel();
                }}
              ></CasesBlockNew>
            ))}
          </div>
        </div>
      </section>
    );
  }
}
export default CasesSection;
